import React from 'react';

const AIInsightsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', flexShrink: 0 }}
    {...props}
  >
    <path
      d="M3.75863 0.403321C3.95761 -0.134414 4.71817 -0.134414 4.91715 0.40332L5.72483 2.58604C5.78739 2.7551 5.92068 2.88839 6.08975 2.95095L8.27246 3.75863C8.81019 3.95761 8.8102 4.71817 8.27246 4.91715L6.08974 5.72483C5.92068 5.78739 5.78739 5.92068 5.72483 6.08975L4.91715 8.27246C4.71817 8.81019 3.95761 8.8102 3.75863 8.27246L2.95095 6.08974C2.88839 5.92068 2.7551 5.78739 2.58604 5.72483L0.403321 4.91715C-0.134414 4.71817 -0.134414 3.95761 0.40332 3.75863L2.58604 2.95095C2.7551 2.88839 2.88839 2.7551 2.95095 2.58604L3.75863 0.403321Z"
      fill="#329AFC"
    />
  </svg>
);

export default AIInsightsIcon;
